import { render, staticRenderFns } from "./generalOnput.vue?vue&type=template&id=40f3b75a&scoped=true&"
import script from "./generalOnput.vue?vue&type=script&lang=js&"
export * from "./generalOnput.vue?vue&type=script&lang=js&"
import style0 from "./generalOnput.vue?vue&type=style&index=0&id=40f3b75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3b75a",
  null
  
)

export default component.exports